import { useEffect, useState } from 'react'

const ZEICHEN = '01<>/#%&§$+*ΔΣΞ'
const DAUER = 1000   // ms je Zeile
const VERSATZ = 220  // ms zwischen den Zeilen

// Zufall nur fuer den Zeichensalat (rein optisch); crypto statt Math.random, damit kein Sicherheitshinweis entsteht
const zufallsZeichen = () => ZEICHEN[crypto.getRandomValues(new Uint32Array(1))[0] % ZEICHEN.length]

const bewegungAus = () =>
  typeof window === 'undefined' || typeof window.matchMedia !== 'function' || window.matchMedia('(prefers-reduced-motion: reduce)').matches

/** Ueberschrift, die sich beim Laden Zeichen fuer Zeichen „entschluesselt“ - passend zum Thema Sicherheit.
 *  Nach rund 1,5 s steht der Text fest; mit reduzierter Bewegung sofort. */
export default function Entschluesseln({ zeilen, className = '' }: Readonly<{ zeilen: string[]; className?: string }>) {
  // Fortschritt je Zeile: Anzahl bereits entschluesselter Zeichen
  const [fertig, setFertig] = useState<number[]>(() => (bewegungAus() ? zeilen.map(z => z.length) : zeilen.map(() => 0)))

  useEffect(() => {
    if (bewegungAus()) return undefined
    const start = performance.now()
    let raf = 0
    const schritt = (t: number) => {
      const neu = zeilen.map((z, i) => Math.floor(Math.min(1, Math.max(0, (t - start - i * VERSATZ) / DAUER)) * z.length))
      setFertig(neu)
      if (neu.some((n, i) => n < zeilen[i].length)) raf = requestAnimationFrame(schritt)
    }
    raf = requestAnimationFrame(schritt)
    return () => cancelAnimationFrame(raf)
  }, [zeilen])

  return (
    <h1 className={className} aria-label={zeilen.join(' ')}>
      {zeilen.map((z, i) => (
        <span key={z} aria-hidden="true" className="block whitespace-nowrap">
          {z.slice(0, fertig[i])}
          <span className="text-konf-hell/70">
            {[...z.slice(fertig[i])].map(ch => (ch === ' ' ? ' ' : zufallsZeichen())).join('')}
          </span>
        </span>
      ))}
    </h1>
  )
}
